module.exports = __webpack_public_path__ + "static/media/waz-car.931528e4.png";